import { useQuery } from '@tanstack/react-query';

import { TransactionsApi } from '../../apis';
import { QueryKeys } from '../query-keys';

/** What the movements that match the filter add up to, all of them and not just the page that is shown. */
const useTransactionsSummary = (filter = {}) => {
  const query = useQuery({
    queryKey: [QueryKeys.TRANSACTIONS, 'summary', filter],
    queryFn: () => TransactionsApi.getSummary(filter),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    summary: query.data || {
      transactionsCount: 0,
      byTransactionType: [],
    },
  };
};

export default useTransactionsSummary;
